export function initHeroCard() {
    var root = document.querySelector('[data-museum-hero-card]');

    if (!root) {
        return;
    }

    initGallery(root);
    initCandle(root);
}

function initGallery(root) {
    var gallery = root.querySelector('[data-museum-hero-gallery]');

    if (!gallery) {
        return;
    }

    var mainImg = gallery.querySelector('[data-museum-hero-main-img]');
    var thumbs = gallery.querySelectorAll('[data-museum-hero-thumb]');

    if (!mainImg || !thumbs.length) {
        return;
    }

    thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
            var src = thumb.getAttribute('data-src');

            if (!src) {
                return;
            }

            mainImg.src = src;
            thumbs.forEach(function (item) {
                var active = item === thumb;
                item.classList.toggle('is-active', active);
                item.setAttribute('aria-pressed', active ? 'true' : 'false');
            });
        });
    });
}

function initCandle(root) {
    var candle = root.querySelector('[data-museum-candle]');

    if (!candle) {
        return;
    }

    var btn = candle.querySelector('[data-museum-candle-light]');
    var thanks = candle.querySelector('[data-museum-candle-thanks]');

    if (!btn) {
        return;
    }

    btn.addEventListener(
        'click',
        function () {
            if (candle.classList.contains('is-lit')) {
                return;
            }

            candle.classList.add('is-lit');
            btn.disabled = true;
            btn.setAttribute('aria-disabled', 'true');

            var labelAction = btn.querySelector('.museum-candle__btn-text--action');
            var labelDone = btn.querySelector('.museum-candle__btn-text--done');

            if (labelAction) {
                labelAction.hidden = true;
            }

            if (labelDone) {
                labelDone.hidden = false;
            }

            if (thanks) {
                thanks.setAttribute('aria-hidden', 'false');
                thanks.classList.add('is-visible');
            }
        },
        { once: true }
    );
}
